import * as React from 'react'
import { Typography, Link, IconButton, Tooltip } from '@material-ui/core'
import { generatePath, Link as RouterLink } from 'react-router-dom'
import { siteRoute, idRoute } from '../../App'
import { Site } from '../../store/Site'
import theme from 'theme'
import ContentCopyIcon from '@material-ui/icons/FileCopy'

interface Props {
  readonly site: Site
}

function SiteInfoWindow({ site }: Props) {
  const [assetCountsByType] = React.useState(() => {
    return {
      Tanks: site.tanks.length,
      gasFlows: site.gasFlows.length,
      Heaters: site.heaters.length,
    }
  })

  const [copied, setCopied] = React.useState(false)

  const handleCopy = async () => {
    try {
      const coords = `${site.latitude}, ${site.longitude}`
      await navigator.clipboard.writeText(coords)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Error copying: ', err)
    }
  }

  return (
    <div>
      <Typography>
        <Link
          component={RouterLink}
          to={generatePath(siteRoute + idRoute, {
            id: site.id,
          })}
        >
          {site.name || site.id}
        </Link>
      </Typography>

      <Typography style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title={copied ? 'Copied!' : 'Copy coordinates'}>
          <IconButton size="small" onClick={handleCopy}>
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        &nbsp;Lat/Lon:&nbsp;{site.latitude},&nbsp;{site.longitude}
      </Typography>

      {/* <Typography>Assets count:</Typography>
      {Object.entries(assetCountsByType).map(([assetType, count], index) => {
        return (
          <Typography
            key={index}
            variant="subtitle2"
            style={{
              marginLeft: theme.spacing(1),
            }}
          >
            {assetType}: {count}
          </Typography>
        )
      })} */}
    </div>
  )
}

export default SiteInfoWindow
